import React, { useState, useEffect, useRef } from 'react';
import { Link, withRouter } from 'react-router-dom';

// Grupos del menú. `href` para anclas fuera de react-router, `to` para rutas internas.
const MENU_GRUPOS = [
    {
        id: 'internet',
        titulo: 'Internet',
        links: [
            { href: '/#planesInternet', texto: 'Planes' },
            { to: '/cobertura', texto: 'Cobertura', badge: 'Nuevas' },
            { to: '/promociones', texto: 'Promociones' },
            { to: '/beneficios', texto: 'Beneficios' },
            { to: '/internet/faq', texto: 'Preguntas frecuentes' },
        ],
    },
    {
        id: 'compania',
        titulo: 'Compañía',
        links: [
            { to: '/nosotros', texto: 'Nosotros' },
            { to: '/blog', texto: 'Blog' },
            { to: '/podcasts', texto: 'Podcasts' },
            { to: '/becas', texto: 'Becas' },
            { to: '/concursos', texto: 'Concursos' },
            { to: '/documentacion', texto: 'Documentación' },
            { to: '/privacidad', texto: 'Privacidad' },
        ],
    },
];

const MenuLink = ({ link, onClick }) => {
    const contenido = (
        <>
            {link.texto}
            {link.badge && <span className="navItmex-badge">{link.badge}</span>}
        </>
    );
    return link.to
        ? <Link className="navItmex-dropdown-link" to={link.to} onClick={onClick}>{contenido}</Link>
        : <a className="navItmex-dropdown-link" href={link.href} onClick={onClick}>{contenido}</a>;
};

const Menu = ({ location }) => {
    const [abierto, setAbierto] = useState(null);      // id del dropdown abierto (escritorio)
    const [movilAbierto, setMovilAbierto] = useState(false);
    const navRef = useRef(null);

    // Cierra todo al cambiar de ruta
    useEffect(() => {
        setAbierto(null);
        setMovilAbierto(false);
    }, [location.pathname]);

    // Cierra el dropdown al hacer clic fuera o con Escape
    useEffect(() => {
        const cerrar = (e) => {
            if (e.type === 'keydown' ? e.key === 'Escape' : !navRef.current.contains(e.target)) {
                setAbierto(null);
            }
        };
        document.addEventListener('mousedown', cerrar);
        document.addEventListener('keydown', cerrar);
        return () => {
            document.removeEventListener('mousedown', cerrar);
            document.removeEventListener('keydown', cerrar);
        };
    }, []);

    const cerrarTodo = () => {
        setAbierto(null);
        setMovilAbierto(false);
    };

    return (
        <header className="navItmex-wrapper">
            <nav className="navItmex" ref={navRef} aria-label="Principal">
                <Link to="/" className="navItmex-logo" aria-label="Red Itmex - Inicio">
                    <img src="/assets/img/logos/LOGOMINNEGRO.png" alt="Red Itmex" />
                </Link>

                <ul className="navItmex-links">
                    {MENU_GRUPOS.map(grupo => (
                        <li key={grupo.id}
                            className="navItmex-item"
                            onMouseEnter={() => setAbierto(grupo.id)}
                            onMouseLeave={() => setAbierto(null)}>
                            <button type="button"
                                className="navItmex-link"
                                aria-haspopup="true"
                                aria-expanded={abierto === grupo.id}
                                onClick={() => setAbierto(abierto === grupo.id ? null : grupo.id)}>
                                {grupo.titulo}
                                <i className="fas fa-chevron-down navItmex-chevron"></i>
                            </button>
                            {abierto === grupo.id && (
                                <div className="navItmex-dropdown">
                                    {grupo.links.map(link => <MenuLink key={link.texto} link={link} onClick={cerrarTodo} />)}
                                </div>
                            )}
                        </li>
                    ))}
                    <li className="navItmex-item">
                        <Link className="navItmex-link" to="/contacto">Contacto</Link>
                    </li>
                </ul>

                <div className="navItmex-actions">
                    <Link className="navItmex-cta" to="/contacto">
                        <span className="navItmex-cta-arrow"><i className="fas fa-arrow-right"></i></span>
                        Contratar
                    </Link>
                    <button type="button"
                        className="navItmex-toggler"
                        aria-label={movilAbierto ? 'Cerrar menú' : 'Abrir menú'}
                        aria-expanded={movilAbierto}
                        onClick={() => setMovilAbierto(!movilAbierto)}>
                        <i className={movilAbierto ? 'fas fa-times' : 'fas fa-bars'}></i>
                    </button>
                </div>
            </nav>

            {movilAbierto && (
                <div className="navItmex-mobile">
                    {MENU_GRUPOS.map(grupo => (
                        <div key={grupo.id} className="navItmex-mobile-grupo">
                            <span className="navItmex-mobile-titulo">{grupo.titulo}</span>
                            {grupo.links.map(link => <MenuLink key={link.texto} link={link} onClick={cerrarTodo} />)}
                        </div>
                    ))}
                    <div className="navItmex-mobile-grupo">
                        <Link className="navItmex-dropdown-link" to="/contacto" onClick={cerrarTodo}>Contacto</Link>
                    </div>
                </div>
            )}
        </header>
    )
}
export default withRouter(Menu);
